import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { initTheme } from "./modules/theme.js";
import { initMobileNav } from "./modules/nav.js";
import { initCursor } from "./modules/cursor.js";
import { initReveals } from "./modules/reveals.js";
import { initHeroTerrain } from "./modules/hero-terrain.js";
import { initGalleryLightbox } from "./modules/lightbox.js";
import { prefersReducedMotion } from "./modules/motion-utils.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  initTheme();
  initMobileNav();
  initCursor();
  initGalleryLightbox();

  // Anything below this line is purely aesthetic motion and is skipped
  // entirely for users who have asked the OS for reduced motion.
  if (!prefersReducedMotion()) {
    initReveals(gsap);
    initHeroTerrain();
  }
});
